<app-mini-loader *ngIf="loading"></app-mini-loader>
<app-colapsable
  [info]="info"
  [mostrarInfo]="mostrarInfo"
  *ngIf="datoContratante && !loading"
  title="DATOS DEL CONTRATANTE"
  [expanded]="expanded"
  ($expandedChange)="expandChange()"
>
  <div description class="colapsable-panel-description non-mobile-only">
    <app-form-lablel [label]="'Nombre:'"></app-form-lablel>
    <app-form-text [text]="getFullName()"></app-form-text>
    <div class="spacer"></div>
    <app-form-lablel [label]="'Rut:'"></app-form-lablel>
    <app-form-text [text]="formatRUT(datoContratante?.Rut)"></app-form-text>
  </div>
  <div body [ngSwitch]="editMode">
    <app-error *ngIf="error"></app-error>
    <div *ngIf="datoContratante">
      <div *ngSwitchDefault class="vertical-flex">
        <div class="mobile-only responsive-row-2 responsive-group">
          <div class="data-pair">
            <span class="label">Nombre:</span>
            <span class="uppercase value">{{ getFullName() }}</span>
          </div>
          <div class="data-pair">
            <span class="label">Rut:</span>
            <span class="uppercase value">{{
              formatRUT(datoContratante?.Rut)
            }}</span>
          </div>
        </div>
        <div class="responsive-row-2">
          <div class="data-pair">
            <span class="label">Teléfono particular</span>
            <span class="uppercase value"
              >+56 {{ datoContratante?.Celular || '' }}</span
            >
          </div>
          <div class="data-pair">
            <span class="label">Teléfono comercial</span>
            <span class="uppercase value"
              >+56 {{ datoContratante?.TelefonoComercial || '' }}</span
            >
          </div>
          <div class="data-pair">
            <span class="label">Correo electrónico</span>
            <span class="uppercase value">{{
              datoContratante?.Correo || '-'
            }}</span>
          </div>
        </div>

        <div class="data-pair">
          <span class="label">Dirección Particular</span>
          <span
            class="uppercase value"
            *ngIf="datoContratante && datoContratante.Direccion"
          >
            {{ datoContratante?.Direccion }},
            {{
              getNombreComunaByCodigo(
                datoContratante?.CodigoComuna,
                'direccion'
              )
            }},
            {{
              getNombreCuidadByCodigo(
                datoContratante?.CodigoCiudad,
                'direccion'
              )
            }},
            {{
              getNombreRegionByCodigo(
                datoContratante?.CodigoRegion,
                'direccion'
              )
            }}</span
          >
        </div>

        <div class="data-pair">
          <span class="label">Dirección Comercial</span>
          <span
            class="uppercase value"
            *ngIf="datoContratante && datoContratante.DireccionComercial"
            >{{ datoContratante?.DireccionComercial }},
            {{
              getNombreComunaByCodigo(
                datoContratante?.CodigoComunaComerc,
                'direccionComerc'
              )
            }},
            {{
              getNombreCuidadByCodigo(
                datoContratante?.CodigoCiudadComerc,
                'direccionComerc'
              )
            }},
            {{
              getNombreRegionByCodigo(
                datoContratante?.CodigoRegionComerc,
                'direccionComerc'
              )
            }}</span
          >
        </div>

        <div class="data-pair">
          <span class="label">Dirección Envío Correspondencia</span>
          <span
            class="uppercase value"
            *ngIf="datoContratante && datoContratante.DireccionCorres"
            >{{ datoContratante?.DireccionCorres }},
            {{
              getNombreComunaByCodigo(
                datoContratante?.CodigoComunaCorres,
                'direccionCorres'
              )
            }},
            {{
              getNombreCuidadByCodigo(
                datoContratante?.CodigoCiudadCorres,
                'direccionCorres'
              )
            }},
            {{
              getNombreRegionByCodigo(
                datoContratante?.CodigoRegionCorres,
                'direccionCorres'
              )
            }}</span
          >
        </div>

        <!-- <div class="data-pair">
          <span class="label">Dirección comercial</span>
          <span class="uppercase value">{{
            datoContratante?.DireccionComercial || '-'
          }}</span>
        </div> -->

        <div class="vseparator" *ngIf="lineaNegocio != 'RRVV'"></div>

        <div class="col-12" align="right" *ngIf="lineaNegocio != 'RRVV'">
          <button
            mat-flat-button
            type="submit"
            [color]="'primary'"
            class="btn  btn-primary btn-primary-vs"
            (click)="onEditMode()"
          >
            Modificar Datos
          </button>
        </div>
      </div>

      <div *ngSwitchCase="true">
        <form [formGroup]="form" class="vertical-flex">
          <div class="responsive-row-2 responsive-group">
            <div class="form-field">
              <app-form-input-text
                [label]="'Teléfono particular'"
                [maxlength]="9"
                [messageError]="getErrorMessage(form, 'Celular')"
                [prefix]="'+56'"
                formControlName="Celular"
                autocomplete="off"
              >
              </app-form-input-text>
            </div>
            <div class="form-field">
              <app-form-input-text
                [label]="'Teléfono comercial'"
                [maxlength]="9"
                [messageError]="getErrorMessage(form, 'TelefonoComercial')"
                [prefix]="'+56'"
                formControlName="TelefonoComercial"
                autocomplete="off"
              >
              </app-form-input-text>
            </div>
            <div class="form-field no-margin">
              <app-form-input-text
                [label]="'Correo electrónico'"
                [messageError]="getErrorMessage(form, 'Correo')"
                formControlName="Correo"
                autocomplete="off"
              >
              </app-form-input-text>
            </div>
          </div>

          <div class="responsive-group">
            <div class="form-field">
              <app-form-input-text
                [hasError]="false"
                [label]="'Dirección particular (calle, número, depto.)'"
                [messageError]="getErrorMessage(form, 'Direccion')"
                formControlName="Direccion"
                autocomplete="off"
              >
              </app-form-input-text>
            </div>

            <div class="responsive-row-2">
              <div class="form-field ">
                <app-form-select
                  formControlName="CodigoRegion"
                  [options]="regiones"
                  [optionDescription]="'Nombre'"
                  [label]="'Región'"
                  ($onChange)="regionOnChange($event)"
                  [messageError]="getErrorMessage(form, 'CodigoRegion')"
                  [optionValue]="'CodigoRegion'"
                >
                </app-form-select>
              </div>
              <div class="form-field">
                <app-form-select
                  formControlName="CodigoCiudad"
                  [options]="ciudades"
                  [optionDescription]="'Nombre'"
                  [optionValue]="'CodigoCiudad'"
                  [label]="'Ciudad'"
                  ($onChange)="ciudadOnChange($event)"
                  [messageError]="getErrorMessage(form, 'CodigoCiudad')"
                ></app-form-select>
              </div>
              <div class="form-field no-margin">
                <app-form-select
                  formControlName="CodigoComuna"
                  [options]="comunas"
                  [optionDescription]="'Nombre'"
                  [optionValue]="'CodigoComuna'"
                  [label]="'Comuna'"
                  [messageError]="getErrorMessage(form, 'CodigoComuna')"
                ></app-form-select>
              </div>
            </div>
          </div>

          <div class="responsive-group">
            <div class="form-field">
              <app-form-input-text
                [hasError]="false"
                [label]="'Dirección Comercial (calle, número, depto.)'"
                [messageError]="getErrorMessage(form, 'DireccionComercial')"
                formControlName="DireccionComercial"
                autocomplete="off"
              >
              </app-form-input-text>
            </div>

            <div class="responsive-row-2">
              <div class="form-field">
                <app-form-select
                  formControlName="CodigoRegionComerc"
                  [options]="regiones"
                  [optionDescription]="'Nombre'"
                  [label]="'Región'"
                  ($onChange)="regionOnChangeComerc($event)"
                  [messageError]="getErrorMessage(form, 'CodigoRegionComerc')"
                  [optionValue]="'CodigoRegion'"
                >
                </app-form-select>
              </div>
              <div class="form-field">
                <app-form-select
                  formControlName="CodigoCiudadComerc"
                  [options]="ciudadesComerc"
                  [optionDescription]="'Nombre'"
                  [optionValue]="'CodigoCiudad'"
                  [label]="'Ciudad'"
                  ($onChange)="ciudadOnChangeComerc($event)"
                  [messageError]="getErrorMessage(form, 'CodigoCiudadComerc')"
                ></app-form-select>
              </div>

              <div class="form-field no-margin">
                <app-form-select
                  formControlName="CodigoComunaComerc"
                  [options]="comunasComerc"
                  [optionDescription]="'Nombre'"
                  [optionValue]="'CodigoComuna'"
                  [label]="'Comuna'"
                  [messageError]="getErrorMessage(form, 'CodigoComunaComerc')"
                ></app-form-select>
              </div>
            </div>
          </div>

          <div class="responsive-group">
            <div class="form-field">
              <app-form-input-text
                [hasError]="false"
                [label]="
                  '* Dirección Envío Correspondencia (calle, número, depto.)'
                "
                [messageError]="getErrorMessage(form, 'DireccionCorres')"
                formControlName="DireccionCorres"
                autocomplete="off"
              >
              </app-form-input-text>
            </div>

            <div class="responsive-row-2">
              <div class="form-field">
                <app-form-select
                  formControlName="CodigoRegionCorres"
                  [options]="regiones"
                  [optionDescription]="'Nombre'"
                  [label]="'Región'"
                  ($onChange)="regionOnChangeCorres($event)"
                  [messageError]="getErrorMessage(form, 'CodigoRegionCorres')"
                  [optionValue]="'CodigoRegion'"
                >
                </app-form-select>
              </div>
              <div class="form-field">
                <app-form-select
                  formControlName="CodigoCiudadCorres"
                  [options]="ciudadesCorres"
                  [optionDescription]="'Nombre'"
                  [optionValue]="'CodigoCiudad'"
                  [label]="'Ciudad'"
                  ($onChange)="ciudadOnChangeCorres($event)"
                  [messageError]="getErrorMessage(form, 'CodigoCiudadCorres')"
                ></app-form-select>
              </div>
              <div class="form-field no-margin">
                <app-form-select
                  formControlName="CodigoComunaCorres"
                  [options]="comunasCorres"
                  [optionDescription]="'Nombre'"
                  [optionValue]="'CodigoComuna'"
                  [label]="'Comuna'"
                  [messageError]="getErrorMessage(form, 'CodigoComunaCorres')"
                ></app-form-select>
              </div>
            </div>
          </div>

          <!-- <div class="form-field">
            <app-form-input-text
              [label]="'Dirección comercial'"
              [messageError]="getErrorMessage(form, 'DireccionComercial')"
              formControlName="DireccionComercial"
            >
            </app-form-input-text>
          </div> -->

          <div class="vseparator"></div>

          <div class="container-button">
            <button
              (click)="offEditMode()"
              mat-stroked-button
              type="button"
              class="button-detail"
            >
              Cancelar
            </button>
            <button
              type="button"
              [disabled]="!form.valid || !form.dirty"
              (click)="save()"
              mat-flat-button
            >
              Guardar
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</app-colapsable>
